import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { Typography } from "@mui/material";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import {getAllProductBatches, batchChangeReport} from "../../utilityFunctions/WarehouseUtil.js";
import { PuffLoader } from "react-spinners";
import { css } from "@emotion/react";
import Colors from "../../components/ui/Colors";

const cssLoader = css`
  display: block;
  margin-left: auto;
  margin-right: auto;
`;

const dateOptions = {
    // weekday: "short",
    day: "numeric",
    month: "numeric",
    year: "numeric",
};

export default function BatchChangesReport(props) {

    const{loginUser} = props;

    const [loading, setLoading] = React.useState(false);

    React.useEffect(()=> {
        setLoading(true);
        renderChangesReport();
    }, []);

    const initialValues = async () => {
        setLoading(true);
        // const batches = await getAllProductBatches(loginUser.jwtToken);
        const changes = await batchChangeReport(loginUser.jwtToken);
        setLoading(false);

        return changes;
    };

    const [changesReport, setChangesReport] = React.useState("");

    const renderChangesReport = async () => {
        const changes = await initialValues();

        if(!changes){
            return;
        }

        // Sort changes array by date in descending order
        const sortedChanges = [...changes].sort((a, b) => new Date(b.date) - new Date(a.date));

        setChangesReport(
            <List sx={{width: "100%", marginTop: {xs: "3rem", sm: "2rem", md: "2rm"}}}>
                {sortedChanges.map((change) => {
                        return(
                            <ListItem key={change.changeId} disablePadding divider sx={{marginBottom: "1.5rem"}}>
                                <Grid container spacing={1}>
                                    <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                        <Typography variant="body2">{change.batchId}</Typography>
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                        <Typography variant="body2">{change.description}</Typography>
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                        <Typography variant="body2">{change.username}</Typography>
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                        <Typography variant="body2">{new Intl.DateTimeFormat('es-CO', dateOptions).format(new Date(change.date))}</Typography>
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                        <Typography variant="body2">{new Intl.NumberFormat('es-CO').format(change.initialAmount)}</Typography>
                                    </Grid>
                                    <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                        <Typography variant="body2">{new Intl.NumberFormat('es-CO').format(change.finalAmount)}</Typography>
                                    </Grid>
                                </Grid>
                            </ListItem>
                        )
                    })
                }
            </List>
        );
    };

    return (
        <Box sx={{display: "flex", justifyContent: "center", width: "100%", height: "100%"}}>
            <Box
                sx={{
                    display: "flex",
                    // flex: 1,
                    justifyContent: "center",
                    alignItems: {xs: "start", sm: "center"},
                    width: "90%",
                    height: "100%",
                    textAlign: "center",
                    overflowY: "scroll",
                }}
            >
            {loading ? <PuffLoader size={100} color={Colors.secondary} css={cssLoader} /> : 
                <Grid container>
                    <Grid item xs={12} sm={12} md={12}>
                        <Grid container sx={{marginTop: "1rem"}}>
                            <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                <Typography variant="body1" sx={{color: "black", fontWeight: "bold", textDecoration: 'underline',}}>Código Estiba</Typography>
                            </Grid>
                            <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                <Typography variant="body1" sx={{color: "black", fontWeight: "bold", textDecoration: 'underline',}}>Producto</Typography>
                            </Grid>
                            <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                <Typography variant="body1" sx={{color: "black", fontWeight: "bold", textDecoration: 'underline',}}>Usuario</Typography>
                            </Grid>
                            <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                <Typography variant="body1" sx={{color: "black", fontWeight: "bold", textDecoration: 'underline',}}>Fecha</Typography>
                            </Grid>
                            <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                <Typography variant="body1" sx={{color: "black", fontWeight: "bold", textDecoration: 'underline',}}>Cantidad Inicial</Typography>
                            </Grid>
                            <Grid item xs={2} sm={2} md={2} sx={{display: "flex", justifyContent: "center"}}>
                                <Typography variant="body1" sx={{color: "black", fontWeight: "bold", textDecoration: 'underline',}}>Cantidad Final</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                        {changesReport}
                    </Grid>
                </Grid>
            }
            </Box>
        </Box>
    )
}
